import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, Typography, useTheme } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React from 'react'

const DateOrPresentInput = ( { attr, value, attrkey, handleFieldChange } ) => {

    const { components } = useTheme()

    return (
        <Box sx={{ flexGrow: "1" }}>
            <Box display="flex" alignItems="flex-end" gap="5px">
                {value !== "present" && <Box>
                    <Typography component="label" htmlFor={attrkey} variant="subtitle2" gutterBottom>{attr.entity_detail.label}</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            {...( components?.MuiPickerOutlinedInput?.defaultProps || {} )}
                            format='DD-MM-YYYY'
                            value={dayjs( value ? value : dayjs( "2000-01-01" ) )}
                            onChange={( val ) => {
                                if ( val && val.isValid() )
                                    handleFieldChange( "dateorpresent", attrkey, new Date( val ).toLocaleDateString( 'en-US' ) )
                            }}
                        />
                    </LocalizationProvider>
                </Box>
                }
                <FormControl margin='dense' fullWidth sx={{ flexGrow: "1" }}>
                    <FormControlLabel sx={{ marginLeft: "10px" }} control={<Checkbox size='small' color='primary' onChange={( e ) => handleFieldChange( "dateorpresent", attrkey, e.target.checked ? "present" : "" )} checked={value === "present" ? true : false} />} label={<Typography color="GrayText" fontSize="14px">Present</Typography>} />
                </FormControl>
            </Box>
        </Box>
    )
}

export default DateOrPresentInput
